/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'
import useUtils from './useUtils'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'

function Card({sub, setLoading, benefits, setSubscriptions, pricing, currency, limit, offset}) {
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const {handleDelete, fetchBenefits} = useUtils()

  const [benefitIds, setBenefitIds] = useState(
    sub?.subscriptionBenefits?.map((val) => val?.benefit?.id)
  )

  const navigate = useNavigate()
  const handleEdit = (values) => {
    navigate('/subscriptionlist/editSubscription', {state: {values}})
  }

  const onDelete = (id, state) => {
    setSelectedId(id)
    setSelectedState(state)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await handleDelete(selectedId, selectedState, limit, offset)
      setSubscriptions(result)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  return (
    <>
      <div className='card h-100 shadow'>
        <div className='card-header border-0 pt-9'>
          <div className='card-toolbar m-0'>
            <div style={{cursor: 'pointer'}} onClick={() => handleEdit(sub)}>
              <KTSVG
                path='/media/icons/duotune/general/gen055.svg'
                className='svg-icon-3 svg-icon-primary'
              />
            </div>
          </div>

          <div className='card-toolbar'>
            <span
              className={`badge ${
                sub?.isActive ? 'badge-light-success' : 'badge-light-danger'
              } fw-bolder me-auto px-4 py-3`}
            >
              {sub?.isActive ? 'active' : 'inActive'}
            </span>
          </div>
        </div>

        <div className='card-body d-flex flex-column px-9 pt-6 '>
          <div className='fs-3 fw-bolder text-dark'>{sub?.name}</div>
          <ul
            className='list-unstyled text-gray-600 fw-bold fs-5 mt-3 mb-3'
            style={{lineHeight: '1.5'}}
          >
            {sub?.detail?.split('\n').map((str, index) => (
              <li key={index} className='mb-2 d-flex align-items-center'>
                <span
                  className='bullet bg-danger me-2 '
                  style={{width: '7px', height: '7px'}}
                ></span>
                <div className=' flex-grow-1'>{str}</div>
              </li>
            ))}
          </ul>

          {pricing === 'Monthly' && (
            <>
              <div className='d-flex  align-items-center gap-3'>
                <div className='fs-1 text-dark fw-bolder'>{`$ ${sub?.monthlyPrice}`}</div>

                <div className='fw-bold text-gray-700'>every month</div>
              </div>
            </>
          )}

          {pricing === 'Yearly' && (
            <>
              <div className='d-flex align-items-center gap-3'>
                <div className='fs-1 text-dark fw-bolder'>{`$ ${sub?.yearlyPrice}`}</div>
                <div className='fw-bold text-gray-700'>every year</div>
              </div>
            </>
          )}

          <div className='d-flex flex-column mt-10'>
            <div className='fs-4 fw-bolder text-dark mb-5'>Benefits</div>
            {benefits?.map((benefit) => (
              <div className='d-flex justify-content-between' key={benefit.id}>
                <div style={{fontSize: '12.3', fontWeight: 600}}>{benefit.name}</div>
                <div>
                  <label className='form-check form-check-custom form-check-solid form-switch mb-3'>
                    <input
                      className='form-check-input-sm'
                      type='checkbox'
                      name='layout-builder[layout][header][fixed][desktop]'
                      checked={benefitIds?.includes(benefit.id)}
                    />
                  </label>
                </div>
              </div>
            ))}

            <div
              onClick={() => onDelete(sub?.id, !sub?.isActive)}
              className='d-flex justify-content-center mt-10'
            >
              <a href='#' className={`btn btn-sm ${sub?.isActive ? 'btn-danger' : 'btn-success'}`}>
                {sub?.isActive ? 'Deactivate' : 'Activate'}
              </a>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmation
        isVisible={modalVisible}
        message={
          sub?.isActive
            ? 'Are you sure you want to deactivate this Subscription ?'
            : 'Are you sure you want to activate this Subscription?'
        }
        onConfirm={confirmDelete}
        onCancel={() => setModalVisible(false)}
      />
    </>
  )
}

export default Card
